/**
 * 
 *
 * 调用方式
 *      v-permission="'action:invite:report:achieve:dequery'"
 *      或者
 *      v-permission="{
            symbol: 'action:invite:report:achieve:dequery',
            boolean: true, (false) // 默认为true,不传为true
            type: 'or' (and) // 默认为and 和关系，默认为and
        }"
 *
 * @todo 提供权限管控
 */
import store from '../store/store';

function hasPermission (val) {
    // 获取当前权限数组
    let permissionArr = store.state.permission;

    if (permissionArr.length === 0) {
        console.log('权限数组为空');
    }

    if (permissionArr.includes(val)) {
        return true;
    }

    return false;
}

function initPermission (Vue) {
    Vue.directive('permission', {
        bind (el, binding) {
            let obj = binding.value;

            if (obj.constructor === String) {
                if (!hasPermission(obj)) {
                    Vue.nextTick(function () {
                        el.parentNode.removeChild(el);
                    });
                }
            }

            if (obj.constructor === Object) {
                if (obj.type === undefined || obj.type === 'and') {
                    if (obj.boolean === undefined || obj.boolean) {
                        if (!hasPermission(obj.symbol)) {
                            Vue.nextTick(function () {
                                el.parentNode.removeChild(el);
                            });
                        }
                    } else {
                        Vue.nextTick(function () {
                            el.parentNode.removeChild(el);
                        });
                    }
                } else if (obj.type === 'or') {
                    if (obj.boolean === false && !hasPermission(obj.symbol)) {
                        Vue.nextTick(function () {
                            el.parentNode.removeChild(el);
                        });
                    }
                }
            }
        }
    });

    Vue.prototype.hasPermission = hasPermission;
}

export default initPermission;





// WEBPACK FOOTER //
// ./src/directive/permission.js